export const OAUTH_SECURITY_TOKEN_KEY = 'oauth-security-token';
export const OAUTH_CALLBACK_PROCESSED_KEY = 'oauth_callback_processed';
